import {IMuWidget} from "./IMuWidget";
import {copyToClipoard} from "./Utils";

export class ShareButton extends IMuWidget {
	public text : string;

	public html : string|null;

	public link : string|null;

	container : HTMLElement;

	beforeIndex() {
		this.container.innerHTML += '<span class="icon" mu-id="bHtml">&nbsp;</span><span class="share-button--menu"><span mu-id="bMarkdown">Markdown</span>';
	}

	afterIndex() {
		if (!this.container.className) {
			this.container.className = "share-button";
		}
		if (!this.container.title) this.container.title = "Zkopírovat odkaz na požadavek";
	}

	bMarkdown_click() {
		this.copyLink("md");
		event.cancelBubble = true;
		event.preventDefault();
		return false;
	}

	bHtml_click() {
		this.copyLink("html");
		event.cancelBubble = true;
	}

	public copyLink(mode : "html"|"md")
	{
		const content = this.html || this.text || document.title;
		const type : "html"|"text" = this.html ? "html" : "text";
		const link = this.link || document.location.toString();
		let el;
		switch (mode) {
			case "html":
				const a = document.createElement("a");
				a.href = link;
				if (type == "html") a.innerHTML = content;
				else a.innerText = content;
				el = a;
				break;
			case "md":
				el = document.createElement("span");
				el.innerText = "[" + content + "](" + link + ")";
				break;
		}
		copyToClipoard(el.outerHTML, "html");
	}
}